export default {
    name: "SettingsAddUserModal",

    props: {
        is_open: {
            type: Boolean,
            default: false
        },
        is_saving: {
            type: Boolean,
            default: false
        },
        form_error: {
            type: String,
            default: ""
        },
        role_options: {
            type: Array,
            default: () => []
        },
        is_loading_roles: {
            type: Boolean,
            default: false
        }
    },

    emits: ["close", "submit"],

    data() {
        return ({
            user_form: this.get_empty_user_form()
        });
    },

    watch: {
        is_open(next_value) {
            if (next_value) {
                this.user_form = this.get_empty_user_form();
            }
        },

        role_options(next_options) {
            if (!Array.isArray(next_options) || !next_options.length) return;

            if (!this.user_form?.role) {
                this.user_form.role = next_options[0];
                return;
            }

            if (typeof this.user_form.role === "string") {
                const match = next_options.find((role_option) => {
                    if (!role_option) return false;
                    if (typeof role_option === "object") {
                        return role_option.name === this.user_form.role || String(role_option.id) === this.user_form.role;
                    }
                    return role_option === this.user_form.role;
                });

                if (match) {
                    this.user_form.role = match;
                }
            }
        }
    },

    methods: {
        get_empty_user_form() {
            return ({
                first_name: "",
                last_name: "",
                email: "",
                phone_number: "",
                role: this.role_options[0] || ""
            });
        },

        submit_form() {
            const payload = {
                ...this.user_form,
                username: this.user_form.email
            };
            this.$emit("submit", payload);
        }
    }
};
